import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-attachments',
  templateUrl: './Attachments.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => AttachmentsComponent)}]
})
export class AttachmentsComponent extends BaseControlGroupComponent {

    
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    uploadURL: string;
    public attachments: ent.Attachment[] = [];

    attachmentsForm: FormGroup;

    uploadedFiles: any[] = [];
    request: ent.Request;
    requestID: number;

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.request = request;
        this.requestID = request.ID;
        this.attachments = request.Attachments;
    }
    constructor(fb: FormBuilder, private configService: serv.ConfigService, private requestService: serv.RequestService) 
    { 
      super();  
      this.uploadURL = configService.appConfig.UrlBase + Constants._UPLOAD_METHOD;
      let group = {
          
      };
        
      this.attachmentsForm = fb.group(group);

    }

    onBeforeSend(event: any){
        event.xhr.setRequestHeader(Constants._HEADER_REQUEST_ID, this.requestID);
    }

    onUpload(event: any){
        var files: File[] = [];
        files = event.files;
        var validationMessage: ent.ValidationMessage = {Category: "", MessageText: files.length.toString() + " Files Uploaded"};
        var response: ent.Response = {Success:true, ValidationMessages: [validationMessage]};
        this.messageHandlerComponent.handleResponse(response);
        this.getAttachments();
    }

    onDeleteClick(event: any, attachment: ent.Attachment){
        var attachments: ent.Attachment[] = [];
        attachment.RequestID = this.requestID;
        attachments.push(attachment);
        this.requestService.deleteAttachments(attachments).subscribe(x=>{
              this.messageHandlerComponent.handleResponse(x);
              this.getAttachments();})
    }

    getAttachments(){
        var filter: filters.RequestFilter = {RequestID: this.requestID};
        this.requestService.getAttachments(filter).subscribe(x=>{this.attachments = x});
    }

    onDownloadClick(event: any, attachment: ent.Attachment){
        var request: ent.DownloadAttachmentRequest = {RequestID: this.requestID, FileName: attachment.Name};
        this.requestService.downloadAttachment(request).subscribe(x=>{
            var url= window.URL.createObjectURL(x.image);
            //window.open(url);
            var anchor = document.createElement("a");
            anchor.download = x.filename;
            anchor.href = url;
            anchor.click();
        })
    }
}